"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoteDocumentMap = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const note_entity_1 = require("./note.entity");
const file_upload_entity_1 = require("./file-upload.entity");
let NoteDocumentMap = class NoteDocumentMap {
    constructor(noteId, documentId) {
        this.noteId = noteId;
        this.documentId = documentId;
    }
};
exports.NoteDocumentMap = NoteDocumentMap;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], NoteDocumentMap.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "note_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], NoteDocumentMap.prototype, "noteId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "document_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], NoteDocumentMap.prototype, "documentId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => note_entity_1.Note, (note) => note.noteDocs, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "note_id" }),
    tslib_1.__metadata("design:type", Object)
], NoteDocumentMap.prototype, "note", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => file_upload_entity_1.FileUpload, (fileupload) => fileupload.noteDocs, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "document_id" }),
    tslib_1.__metadata("design:type", Object)
], NoteDocumentMap.prototype, "document", void 0);
exports.NoteDocumentMap = NoteDocumentMap = tslib_1.__decorate([
    (0, typeorm_1.Entity)("note_document_map"),
    tslib_1.__metadata("design:paramtypes", [Number, Number])
], NoteDocumentMap);
